export default "__VITE_PUBLIC_ASSET__00151d6a__"